import React from "react";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import "./index.scss";
import { ButtonDialog } from "../../../../components/button-dialog/ButtonDialog";
import { TableVehicles } from "./TableVehicles";
import { numberToCurrency } from "../../../../utils";
import { getCDsFromRouter } from "../../utils";

export default class ModalChangeVehicle extends React.Component {
  constructor(props) {
    super(props);
  }
  onSelecteVehicleType = (e) => {
    this.props.setVehicleToChange(e.value);
  };
  rowClickHandler = (e) => {
    this.props.setVehicleToChange(e.data);
  };
  render() {
    const footer = (
      <div>
        <ButtonDialog
          onClick={() => this.props.onConfirm()}
          button={{
            title: "Confirmar",
            disabled: !this.props.vehicleSelected,
            className: "lognex-btn-highlighted",
            iconClassName: "pi pi-check",
          }}
          dialog={{
            header: "Confirmação",
            modal: false,
            message: "Deseja realmente alterar o tipo de veículo na rota?",
          }}
        ></ButtonDialog>

        <button title="Cancelar" className="lognex-btn-danger" onClick={this.props.onHide}>
          <i className="pi pi-times"></i>
        </button>
      </div>
    );

    // vehiclesDriverAvailable
    console.log("vehiclesDriverAvailable:", this.props.vehiclesDriverAvailable);
     
    const templateCustoKm = (rowData, e) => {
      return <span>{numberToCurrency(parseFloat(rowData.custoKm), "R$")}</span>;
    };

    const templateVehicleAvailable = (rowData, e) => {
      if (!rowData.vehicleAvailables || rowData.vehicleAvailables.length == 0) {
        return <div style={{ width: "100%", background: "#FFF", color: "red", height: "100%" }}>
          Não há veículos disponíveis
        </div>;
      }
      return <div style={{ width: "100%", background: "#FFF", color: "green", height: "100%", overflow: "clip" }}>
        {rowData.vehicleAvailables.map(va => va.plate).join(", ")}
      </div>;
    };

    let columns = [<Column key="selectorColumnVehicleType" selectionMode="single" style={{ width: "3em" }} />];

    const columnsVehicle = [...this.props.columns];
    if (this.props.useVirtualFense && this.props.vehiclesDriverAvailable && this.props.vehiclesDriverAvailable.length > 0) {
      columnsVehicle.push(
        {
          field: "vehicleAvailables",
          header: "Placas Disponíveis",
          columnKey: "vehicleAvailables",
        });
    }

    columns = [
      ...columns,
      ...columnsVehicle.map((col) => {
        if (col.field == "custoKm") {
          return <Column {...col} key={col.field} body={templateCustoKm} style={{ width: "120px" }} />;
        }
        
        if (col.field == "weight") {
          return <Column {...col} key={col.field} style={{ width: "80px" }} />;
        }
        if (col.field == "pallets") {
          return <Column {...col} key={col.field} style={{ width: "80px" }} />;
        }
        if (col.field == "vehicleAvailables") {
          return <Column {...col} key={col.field} body={templateVehicleAvailable} />;
        }

        return <Column {...col} key={col.field} />;
      }),
    ];

    //mostrar somente veiculos que são dos CDs das Ordens
    let vehicles = this.props.vehicles;

    let isDevolucao = false;
    for (let index = 0; index < this.props.routeEditVehicle.shipments.length; index++) {
      if (this.props.routeEditVehicle.shipments[index].dv && this.props.routeEditVehicle.shipments[index].dv == "dv") {
        isDevolucao = true
        break
      }
    }
   
    vehicles.sort((a, b) => {
      return a.pallets - b.pallets;
    });

    return (
      <Dialog
        className="content"
        header={"Alterar o tipo de veículo da rota"}
        footer={footer}
        visible={this.props.visible}
        modal={true}
        onHide={this.props.onHide}
        style={this.props.style || { width: "60vw" }}
      >
        <div style={{ minHeight: "300px" }}>
          <h3>Selecione um veículo para o CD e depósito!</h3>
          <TableVehicles
            records={vehicles}
            columns={columns}
            selectedRow={this.props.vehicleSelected}
            rowClickHandler={this.rowClickHandler}
            onSelectedEventsChange={this.onSelecteVehicleType}
          />
        </div>
      </Dialog>
    );
  }
}
